var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiItemSwiper',{staticClass:"logo-swiper",attrs:{"dataList":_vm.sponsorData,"itemClass":"logo-item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }